import { ca } from '@cian/analytics';

import { IJsonQuery } from '../../../json_query';
import { IOffer, offerHelper } from '../../../offer';
import { getOfferExtra } from '../../../tracking/getOfferExtra';
import { TUser } from '../../../types/user';
import { dealTypeFromJsonQuery } from '../../../utils/category';
import { isSaleFromSuburbanBuilder } from '../../../utils/isSaleFromSuburbanBuilder';
import { getExtendedOfferEventExtra, type TOfferListingType } from '../../../utils/offer/tracking';
import {
  getDealType,
  getHeadline,
  getObjectTypeWithCategory,
  getObjectTypeWithJsonQuery,
  getOfferKpAdvantages,
  getOfferParentId,
} from '../../../utils/trackings';

export function trackPhoneOpened(
  offer: IOffer,
  position: number,
  jsonQuery: IJsonQuery,
  user: TUser,
  offersQty: number,
  queryString: string,
  listingType: TOfferListingType,
  isSimilar?: boolean,
  isFromBrandBlock?: boolean,
  source?: string,
) {
  const { top3Place, hasDiscount, ...analyticsInfo } = offerHelper(offer).getAnalyticsInfo();
  const parentId = getOfferParentId(offer, jsonQuery);
  const dealType = dealTypeFromJsonQuery(jsonQuery);
  const isCountrysideDeveloper = isSaleFromSuburbanBuilder(offer);
  const kpAdvantages = getOfferKpAdvantages(offer);
  const isHotel = offer.dailyrent?.hotelData?.isHotel;
  let extra = getOfferExtra(offer) || {};

  // Хак для отелей, необходимый для быстрого запуска
  let gaLabel: string | null | undefined = offer.gaLabel;
  if (isHotel) {
    gaLabel = gaLabel?.replace(new RegExp(/ga_obj_type=\d*/), 'ga_obj_type=11');
  }

  if (parentId) {
    extra = {
      ...extra,
      parentId,
    };
  }

  if (isCountrysideDeveloper && kpAdvantages) {
    extra = {
      ...extra,
      kpAdvantages,
    };
  }

  if (hasDiscount) {
    extra = {
      ...extra,
      hasDiscount,
    };
  }

  if (offer.contextToken) {
    extra = {
      ...extra,
      context_token: offer.contextToken,
    };
  }

  const product = {
    ...analyticsInfo,
    cianId: offer.cianId,
    dealType: getDealType(dealType),
    headline: getHeadline(offer),
    hiddenBase: Boolean(offer.isInHiddenBase),
    objectType: getObjectTypeWithCategory(offer.category, isCountrysideDeveloper),
    owner: Boolean(offer.isByHomeowner),
    ownerCianId: offer.cianUserId,
    ownerId: offer.userId,
    photosCount: offer.photos ? offer.photos.length : 0,
    position,
    published: offer.status === 'published',
    variant: analyticsInfo.variant ? analyticsInfo.variant.split('/') : undefined,
    podSnos: Boolean(offer.demolishedInMoscowProgramm),
    ...(top3Place && { top3Place }),
    category: undefined,
    quantity: undefined,
    consultant: offer.isDealRequestSubstitutionPhone,
    extra,
  };

  const actionName = isSimilar
    ? 'Open_listing_similar'
    : isFromBrandBlock
      ? 'Open_listing_agent_block'
      : 'Open_listing';

  const pageNumber = window.location.search
    .substr(1)
    .split('&')
    .find(queryPair => /^p$/.test(queryPair.split('=')[0]));

  ca('eventEbc', {
    name: 'oldevent',
    category: 'Phones',
    action: actionName,
    label: gaLabel,

    user: {
      cianUserId: user.isAuthenticated ? user.id : undefined,
      userId: user.isAuthenticated ? user.userId : undefined,
      email: user.isAuthenticated ? user.email : undefined,
      type: user.isAuthenticated && user.userType ? user.userType : 'not_authorized',
    },

    page: {
      pageType: 'Listing',
      region: jsonQuery.region ? String(jsonQuery.region.value[0]) : '1',
      objectType: getObjectTypeWithJsonQuery(jsonQuery),
      dealType: getDealType(dealType),
      siteType: 'desktop',
      sortType: (jsonQuery.sort && jsonQuery.sort.value) || 'default',
      listingType,
      ...getExtendedOfferEventExtra(offer, source),
      offersQty,
      queryString,
      pageNumber: pageNumber ? Number(pageNumber.split('=')[1]) : 1,
    },

    products: [product],

    searchConditions: jsonQuery,
  });
}
